/* global grecaptcha */

'use strict';
import {
	changeZipFancybox,
	configPaypal,
	initPhotoSwipe,
	initPhotoSwipeFromDOM,
	salesRunningTimer
} from "~/public/utilities/utilities";

import responsiveCouponSidebar from "./couponSidebar";
import getCachedScript from "./getCachedScript";

/**
 * Product display page.
 * @namespace
 */
var responsiveProduct = {
	/**
	 * Constant for URL of Braintree client script.
	 * @returns {String}
	 */
	get BRAINTREEGATEWAY_CLIENT_SCRIPT() {
		return 'https://js.braintreegateway.com/web/3.98.0/js/client.min.js';
	},
	/**
	 * Constant for URL of Braintree PayPal checkout script.
	 * @returns {String}
	 */
	get BRAINTREEGATEWAY_PAYPAL_SCRIPT() {
		return 'https://js.braintreegateway.com/web/3.98.0/js/paypal-checkout.min.js';
	},
	/**
	 * The ID of the product being displayed.
	 * @type String
	 */
	productId: null,
	/**
	 * Initializes all event listeners for the product display page. Init is executed on document ready.
	 * @returns {undefined}
	 */
	init: function() {
		// Do the layout changes first.
		let hiddenPriceTooltip = $('#hidden-price-tooltip'),
			itemConditionTooltip = $('#item-condition-tooltip'),
			lowerPriceTooltip = $('#lower-price-tooltip'),
			promotionalContent = $('.promotionalContent'),
			similarItemsForOutOfStock = $('.similarItemsForOutOfStock');

		if (promotionalContent.length > 0) {
			let promotionalContentText = promotionalContent.find('.promotionalContentText').children().not('script');

			if (!promotionalContentText.text().trim().length) {
				// do Nothing
			} else {
				promotionalContent.removeClass('invisible');
			}
		}
		if (similarItemsForOutOfStock.length > 0) {
			similarItemsForOutOfStock.insertAfter('.productNameSection');
		}
		if ($('.vehicleFitMsgLess').length > 0) {
			$('.selectVehicleMsgMore').removeClass('d-none');
		}

		// Load the values for the responsiveProduct properties.
		this.productId = $('#productIDValue').val();

		// set the original price for later processing
		let $productPriceText = $('#product-price-text');
		$productPriceText.data('orig-price', $productPriceText.data('price'));

		// Register the analytics events before registering other events.
		this.eventTracking();

		changeZipFancybox('.productShippingInfoContainer');

		initPhotoSwipeFromDOM('.slider-main');
		initPhotoSwipe('.productReviewsContainer .reviewImg');
		initPhotoSwipe('.reviewsImagesAndVideos .reviewImg');

		responsiveCouponSidebar.init();
		window.onpageshow = function() {
			let extendedOfferCheckboxes = $('#extended-offer-cards .extended-offer-checkbox:checked');

			if (extendedOfferCheckboxes.length) {
				extendedOfferCheckboxes.trigger('change');
			}
		};

		salesRunningTimer();

		this.addToCartController();
		this.clipCouponController();
		this.compatibleVehicleSelector();
		this.bundledSavingsController();
		this.buyNowController();
		this.discontinuedItemController();
		this.fitmentStickyOnScroll();
		this.freeInstallationAccessoriesController();
		this.imageGallary();
		this.itemQtyController();
		this.makeAnOfferController();
		this.priceHiddenOfferController();
		this.productReviewsController();
		this.productYoutubeVideo();
		this.recentlyViewedItemsController();
		this.reportAbuseInit();
		this.searchCompatibleProduct();
		this.slickSlider();
		this.sonicPointsController();
		this.tabPaneCustomSlider();
		this.timeToVoteController();
		this.wiringGuidesController();
		this.warrantyController();

		$(document.body).on('hide.bs.collapse', '#extended-warranty-more-info', function() {
			$('#extended-warranty-read-more').text('Read more');
		});
		$(document.body).on('show.bs.collapse', '#extended-warranty-more-info', function() {
			$('#extended-warranty-read-more').text('Read less');
		});

		$('.reviewVideoThumbnail').click(responsiveProduct.reviewVideo);

		if (hiddenPriceTooltip.length > 0) {
			hiddenPriceTooltip.tooltip({
				customClass: 'hidden-price-tooltip',
				html: true,
				placement: 'auto'
			});
		}
		if (itemConditionTooltip.length > 0) {
			itemConditionTooltip.tooltip({
				html: true,
				placement: 'auto'
			});
		}
		if (lowerPriceTooltip.length > 0) {
			lowerPriceTooltip.tooltip({
				html: true,
				placement: 'auto'
			});
		}
		if ($('.financing-info-tooltip').length > 0) {
			let $financingTooltips = $('.financing-info-tooltip');

			$financingTooltips.popover({
				html: true,
				placement: 'auto',
				trigger: 'manual',
				customClass: 'financing-info-popover',
				content: function() {
					return $(this).siblings('.financing-tooltip-content').html();
				}
			}).on('click', function(e) {
				e.preventDefault();
				e.stopPropagation();
				$(this).popover('toggle');
			});

			$(document).off('click.financingTooltip').on('click.financingTooltip', function(e) {
				if (!$(e.target).closest('.financing-info-tooltip, .financing-info-popover').length) {
					$financingTooltips.popover('hide');
				}
			});
		}
	},
	/**
	 * Sets up custom click event handling for add to cart events with analytics.
	 * @returns {undefined}
	 */
	addToCartController: function() {
		let sentFacebookTrackingRequest = false;

		$('.addProductToCard').click(function() {
			if (!sentFacebookTrackingRequest && !$(this).hasClass('addToCartAccessoryRecommendationLink')) {
				sentFacebookTrackingRequest = true;

				let facebookPixelParameters = {
					content_type: 'product',
					content_ids: [responsiveProduct.productId]
				};

				// GTM event fire
				dataLayer = dataLayer || [];
				dataLayer.push({'event': 'addedToCart', 'facebookPixelParameters': facebookPixelParameters});
			}
		});
	},
	/**
	 * Sets up custom click event handling for paired-promo-add-to-cart class with Facebok analytics.
	 * @returns {undefined}
	 */
	bundledSavingsController: function() {
		let bundledSavings = document.getElementById('bundledSavingsSlider');

		if (bundledSavings) {
			let $bundledSavings = $(bundledSavings),
				$addSection = $('.addSection', $bundledSavings),
				$mainInput = $('.mainInput', $addSection),
				$promoInput = $('.promoInput', $addSection),
				sentFacebookTrackingRequest = false;

			$(document.body).on('click', '.paired-promo-add-to-cart', function(e) {
				if (!sentFacebookTrackingRequest) {
					sentFacebookTrackingRequest = true;

					let facebookPixelParameters = {
						content_type: 'product',
						content_ids: [$mainInput[0].value, $promoInput[0].value]
					};

					// GTM event fire
					dataLayer = dataLayer || [];
					dataLayer.push({'event': 'addedToCart', 'facebookPixelParameters': facebookPixelParameters});
				}
			});
		}
	},
	/**
	 * If "Buy Now" Button Available, Show/Hide Popup modal when "Buy Now" button is clicked.
	 * @returns {undefined}
	 */
	buyNowController: function() {
		$('.buyNowButton').on('click', function() {
			let $this = $(this),
				selectedWarrantyId = $('#selected-extended-warranty-id').val(),
				$ccBuyNowBtn = $('#cc-button-buy-now'),
				ccBuyNowBtnHref = $ccBuyNowBtn.attr('href').replace(/\/extended_warranty_id\/[0-9]*/, '');

			if (selectedWarrantyId && selectedWarrantyId != '0') {
				ccBuyNowBtnHref = ccBuyNowBtnHref + '/extended_warranty_id/' + selectedWarrantyId;
			}

			$ccBuyNowBtn.attr('href', ccBuyNowBtnHref);

			if ($this.data('paypal-loaded')) {
				$('.buyNowContainer').addClass('active');
			} else {
				$.when(
					getCachedScript(responsiveProduct.BRAINTREEGATEWAY_CLIENT_SCRIPT),
					getCachedScript(responsiveProduct.BRAINTREEGATEWAY_PAYPAL_SCRIPT)
				).done(function() {
					$this.data('paypal-loaded', 1);
					// load the button and remove the spinner
					configPaypal(function() {
						$('#paypal-button-spinner').remove();
					});
					$('.buyNowContainer').addClass('active');
				});
			}
		});

		$('.closeButton').on('click', function() {
			$('.buyNowContainer').removeClass('active');
		});
	},
	/**
	 * Adds event handlers for the coupon clipping.
	 * @returns {undefined}
	 */
	clipCouponController: function() {
		let clipCoupon = $('.clipCoupon'),
			couponCode = clipCoupon.data('couponCode'),
			isCouponApplied = clipCoupon.data('couponApplied');

		clipCoupon.click(function() {
			let $this = $(this),
				couponHiddenInput = $this.closest('.couponContent').find('#redeem_coupon');

			if ($this.hasClass('applied')) {
				$this.removeClass('applied').html("+ Apply");
				couponHiddenInput.val('').attr('name', '');
			} else {
				$this.addClass('applied').html("&#10004; Applied!");
				if (!isCouponApplied) {
					couponHiddenInput.val(couponCode).attr('name', 'redeem_coupon');
				}
			}
		});
	},
	/**
	 * Sets up custom click event handling for links replacementProductAnchor,
	 * showMoreProductsAnchor and goToCategoryAnchor with analytics.
	 * @returns {undefined}
	 */
	discontinuedItemController: function() {
		let replacementProductAnchor = document.getElementById('replacementProductAnchor'),
			showMoreProductsAnchor = document.getElementById('showMoreProductsAnchor'),
			goToCategoryAnchor = document.getElementById('goToCategoryAnchor');

		if (replacementProductAnchor) {
			bindGAnchorEvent($(replacementProductAnchor), 'Product', 'Discontinued Product Elements', 'Replacement Product Anchor', 'Click');
		}
		if (showMoreProductsAnchor) {
			bindGAnchorEvent($(showMoreProductsAnchor), 'Product', 'Discontinued Product Elements', 'Show More Products Anchor', 'Click');
		}
		if (goToCategoryAnchor) {
			bindGAnchorEvent($(goToCategoryAnchor), 'Product', 'Discontinued Product Elements', 'Go To Category Anchor', 'Click');
		}
	},
	/**
	 * Sets up all product page event tracking.
	 * @returns {undefined}
	 */
	eventTracking: function() {
		let bundleSlider = $('.bundle-slider');

		// Item Top Ribbon click Tracking
		$(document.body).on('click', '.top-ribbon ul li a', function() {
			let navigationLinksEventLabel = $(this).html();

			ga('send', 'event', 'Item', 'Product - ' + responsiveProduct.productId + ' Ribbon', navigationLinksEventLabel);
		});

		// Vehicle Selection Section Tracking
		$(document.body).on('click', '.afgContenter .select-vehicle', function() {
			ga('send', 'event', 'Item', 'Product - ' + responsiveProduct.productId + ' Form', 'Enter Vehicle');
		});

		$(document.body).on('click', '.ribbon-set-vehicle-btn', function() {
			ga('send', 'event', 'Item', 'Product - ' + responsiveProduct.productId + ' Ribbon', 'Enter Vehicle');
		});

		$(document.body).on('click', '.afgContenter .change-vehicle', function() {
			ga('send', 'event', 'Item', 'Product - ' + responsiveProduct.productId + ' Form', 'Change Fits Vehicle');
		});

		// product Add To Cart Tracking
		$(document.body).on('click', '.addProductToCard', function() {
			ga('send', 'event', 'Item', 'Product - ' + responsiveProduct.productId + ' Form', 'Add To Cart');
		});

		$(document.body).on('click', '.buyNowButton', function() {
			ga('send', 'event', 'Item', 'Product - ' + responsiveProduct.productId + ' Form', 'Buy Now');
		});

		$('.buyWithCreditCardContainer a').on('click', function() {
			ga('send', 'event', 'Item', 'Product - ' + responsiveProduct.productId + ' Form', 'Buy Now with Credit card');
		});

		$(document.body).on('click', '.makeOfferButton', function() {
			ga('send', 'event', 'Item', 'Product - ' + responsiveProduct.productId + ' Form', 'Make offer');
		});

		$(document.body).on('click', '.notifyMeButton', function() {
			ga('send', 'event', 'Item', 'Product - ' + responsiveProduct.productId + ' Form', 'Notify me');
		});

		// bundle and saving tracking
		$(document.body).on('click', '.paired-promo-add-to-cart', function() {
			let addSection = $(this).closest('.addSection'),
				mainItem = addSection.find('.mainInput').val(),
				promoItem = addSection.find('.promoInput').val();

			ga('send', 'event', 'Item', 'Product - ' + responsiveProduct.productId + ' Bundle and Save (' + mainItem + ' - ' + promoItem + ')', 'Add to Cart');
		});

		if (bundleSlider.length > 1) {
			let slickNext = bundleSlider.find('.slick-next'),
				slickPrev = bundleSlider.find('.slick-prev');

			if (!slickNext.hasClass('slick-disabled')) {
				$(".bundle-slider .slick-next").on("click", function() {
					ga('send', 'event', 'Item', 'Product - ' + responsiveProduct.productId + ' Bundle and Save', 'Next arrow');
				});
			}
			if (!slickPrev.hasClass('slick-disabled')) {
				slickPrev.on('click', function() {
					ga('send', 'event', 'Item', 'Product - ' + responsiveProduct.productId + ' Bundle and Save', 'Previous arrow');
				});
			}
		}

		// Accessories Section Tracking
		$(document.body).on('click', '.accessoriesSection nav.tabbedContainer a', function() {
			let accessoryTypeName = $(this).html().replaceAll('"', '');

			ga('send', 'event', 'Item', 'Accessories - ' + responsiveProduct.productId, accessoryTypeName);
		});
		$(document.body).on('click', '.accessoriesSection .addToCartContainer input[type=submit]', function() {
			let accessoryId = $(this).closest('.addToCartContainer').find('input.hiddenInput').val();

			ga('send', 'event', 'Item', 'Accessories (' + responsiveProduct.productId + ' - ' + accessoryId + ')', 'Add to Cart');
		});

		$(document.body).on('click', '.updateReviewBtn', function() {
			ga('send', 'event', 'Item', 'Product - ' + responsiveProduct.productId + ' Review', 'Update a review');
		});

		$(document.body).on('click', '.writeReviewBtn', function() {
			ga('send', 'event', 'Item', 'Product - ' + responsiveProduct.productId + ' Review', 'Write a review');
		});

		$(document.body).on('click', '.sponsorProductCard a', function() {
			let sponsoredProductId = $(this).data('itemId');
			ga('send', 'event', 'Item', 'Sponsored Product - ' + sponsoredProductId, 'Sponsored Product');
		});
	},
	/**
	 * Adds event handlers for the fitment floating card.
	 * @returns {undefined}
	 */
	fitmentStickyOnScroll: function() {
		let fitmentTopOffset = $('.mainInformation .afgContenter.active').offset(),
			afgContenter = $('.afgContenter');

		if (window.sonicGlobal.isMobile && fitmentTopOffset) {
			window.addEventListener('scroll', function() {
				if (window.screenTop > fitmentTopOffset.top && window.innerHeight > window.innerWidth) {
					afgContenter.addClass('stickyActive');
				} else {
					afgContenter.removeClass('stickyActive');
				}
			}, {passive: true});
		}

		$('.stickyFitmentClose').click(function() {
			afgContenter.removeClass('active');
		});

		$('.selectVehicleMsgMore').click(function() {
			let $this = $(this);

			$this.toggleClass('active');
			if ($this.hasClass('active')) {
				afgContenter.has('.stickyActive').find('.vehicleDetailedMsg').show();
				$this.find('span').html('less info');
			} else {
				afgContenter.has('.stickyActive').find('.vehicleDetailedMsg').hide();
				$this.find('span').html('more info');
			}
		});
	},
	/**
	 * Binds anchor child of .freeInstallationAccessories to call anchorClickModal with a specified
	 * width of 500 or 300 and height of 350.
	 * @returns {undefined}
	 */
	freeInstallationAccessoriesController: function() {
		let freeInstallationAccessories = document.getElementsByClassName('freeInstallationAccessories');

		if (freeInstallationAccessories) {
			let height = 350,
				width;

			if (window.innerWidth > 600) {
				width = 500;
			} else {
				width = 300;
			}

			let anchorClickClosure = function(width, height) {
				return function(e) {
					ga('send', 'event', 'Item', 'Product - ' + responsiveProduct.productId + ' Form', 'Savings see details');
					anchorClickModal(e, width, height);
				};
			}(width, height);

			$(freeInstallationAccessories).click(anchorClickClosure);
		}
	},
	/**
	 * Sets up slick slider on the image gallery.
	 * @returns {undefined}
	 */
	imageGallary: function() {
		this.setProductVideoOrder();

		$('.slider-main').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: false,
			fade: false,
			accessibility: false,
			speed: 300,
			responsive: [
				{
					breakpoint: 992,
					settings: {
						dots: true,
						arrows: false,
						vertical: false
					}
				}
			]
		});

		$('.mainImage.slider-main').css('visibility', 'visible');

		$('.slider-nav').slick({
			slidesToShow: 7,
			slidesToScroll: 1,
			asNavFor: ".slider-main",
			dots: false,
			focusOnSelect: true,
			speed: 1,
			responsive: [
				{
					breakpoint: 1386,
					settings: {
						slidesToShow: 6
					}
				},
				{
					breakpoint: 1200,
					settings: {
						slidesToShow: 6
					}
				},
				{
					breakpoint: 992,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
						dots: true,
						arrows: false,
						vertical: false
					}
				}
			]
		});

		// set gid value to 1 in url when image gallery is open
		$('.mainImage .slick-track').attr('data-pswp-uid', '1');

		$('.moreImage').on('click', function() {
			$('.mainProductImageWrapper.slick-active').find('a').trigger('click');
		});

		$('.video_thumb').on('click', function() {
			$('.mainProductImageWrapper.productVideo').find('a').first().trigger('click');
		});
	},
	/**
	 * Event handlers for the quantity update warning when viewing speakers for multiple locations.
	 * @returns {undefined}
	 */
	itemQtyController: function() {
		$('.disable-qty').click(function(e) {
			e.preventDefault();
			$.fancybox({
				content: $('.qtyUpdateMessage').html(),
				autoCenter: true,
				helpers: {
					overlay: {
						locked: true
					}
				},
				wrapCSS: 'customFancyBox qtyWarningContent'
			});
		});
	},
	/**
	 * This controller handles make an offer form submit data.
	 * Open fancybox with specific width and height on Make Offer button click.
	 * @returns {undefined}
	 */
	makeAnOfferController: function() {
		$(document.body).on('click', '.makeOfferButton', function(e) {
			e.preventDefault();
			$.fancybox({
				content: $('#make-an-offer-container').html(),
				autoCenter: true,
				width: 600,
				helpers: {
					overlay: {
						locked: true
					}
				},
				wrapCSS: 'makeAnOfferContent'
			});
		});

		$(document.body).on('click', '.submitMakeAnOfferBtn', function() {
			// get input values
			let contentLoading = $('.content-loading'),
				offerRequestedPrice = $('.makeAnOfferContent #offerRequestedPrice').val();

			contentLoading.show();
			// send request
			$.ajax({
				url: "/product/makeOffer",
				type: "POST",
				data: {
					productId: responsiveProduct.productId,
					offerRequestedPrice: offerRequestedPrice,
					productMakeAnOffer: true
				}
			}).done(function(response) {
				contentLoading.hide();
				let makeAnOfferInnerContainer = $('.makeAnOfferInnerContainer'),
					makeAnOfferAcceptContainer = $('.makeAnOfferAcceptContainer');

				if (response.success) {
					let offeredPrice = makeAnOfferInnerContainer.find('.offeredPrice');

					offeredPrice.each(function() {
						$(this).html(response.granted_price);
					});
					$('.makeAnOfferRequestContainer, .makeAnOfferHeaderContainer').hide();
					// display success message
					if (response.hasOwnProperty('message')) {
						makeAnOfferAcceptContainer.find('.successMsg').html(response.message);
					}
					makeAnOfferAcceptContainer.show();
				} else {
					makeAnOfferAcceptContainer.hide();
					$('.makeAnOfferRequestContainer').show();
					// display errors
					if (response.hasOwnProperty('errors')) {
						let errorHtml = '',
							errors = response.errors,
							errorContainer = makeAnOfferInnerContainer.find('.errorContainer');

						for (let key in errors) {
							if (errors.hasOwnProperty(key)) {
								errorHtml += '<li>' + errors[key] + '</li>';
							}
						}

						errorContainer.find('.errorMessage').html(errorHtml);
						errorContainer.show();
					}
					// display warning message
					if (response.hasOwnProperty('message')) {
						let errorContainer = makeAnOfferInnerContainer.find('.errorContainer');

						errorContainer.find('.errorMessage').html('<li>' + response.message + '</li>');
						errorContainer.show();
					}
				}
			});
		});
	},
	/**
	 * This controller uses make offer form submit data.
	 * Binding events for submit form (click, keypress, input).
	 * @returns {undefined}
	 */
	priceHiddenOfferController: function() {
		let makeOfferContent = $('#makeOfferContent');

		makeOfferContent.find('input[type=text]').on('input', function(event) {
			event.preventDefault();
			// Remove errors if they exist.
			$('.errorMessage').html('').hide();

			let $this = $(this),
				input = $this.val().trim();

			if (input) {
				$this.removeClass('invalid');
			} else {
				$this.addClass('invalid');
			}
		});

		$(document.body).on('click', '#showOfferButton', function() {
			let canSubmit = true,
				firstName,
				fullName,
				lastName;

			makeOfferContent.find('input[type=text]').each(function() {
				let $this = $(this),
					input = $this.val().trim();

				if (input) {
					$this.removeClass('invalid');
				} else {
					$this.addClass('invalid');
					canSubmit = false;
				}
			});

			if (canSubmit) {
				ga('send', 'event', 'Product', 'Price Hidden', 'Submit');
			} else {
				return false;
			}

			// get input values
			firstName = makeOfferContent.find('#first_name').val();
			lastName = makeOfferContent.find('#last_name').val();
			fullName = firstName + ' ' + lastName;

			let contentLoading = $('.content-loading');

			contentLoading.show();
			// send request
			$.ajax({
				url: "/product/makeOffer",
				type: "POST",
				data: {
					productId: responsiveProduct.productId,
					firstName: firstName,
					lastName: lastName
				}
			}).done(function(response) {
				contentLoading.hide();
				if (response.success) {
					makeOfferContent.addClass('d-none');
					let productPointsContent = $('.productPointsContent'),
						withWarrantyText = productPointsContent.find('#with-warranty-text');

					// Populate price values for Extended Warranty.
					$('#mail-in-rebate-price').html('$' + response.price_offered);
					productPointsContent.find('#product-price-text')
						.html(response.price_after_rebate < 0.01 ? 'FREE' : '$' + response.price_after_rebate)
						.data('price', response.price_after_rebate);
					if (withWarrantyText.hasClass('active')) {
						responsiveProduct.withWarrantyPrice(withWarrantyText.data('price'), true);
					}

					// Display message.
					productPointsContent.find('.fullName').text(fullName);
					productPointsContent.removeClass('d-none');
					$('.makeOfferCall, .addToCartAccessoryRecommendationLink, .submitButton').removeClass('d-none');
				} else {
					if (response.hasOwnProperty('errors')) {
						let errorHtml = '';

						for (let key in response.errors) {
							if (response.errors.hasOwnProperty(key)) {
								errorHtml += '<li>' + response.errors[key] + '</li>';
							}
						}
						// Display errors.
						makeOfferContent.find('.errorMessage').html(errorHtml).show();
					}
				}
			});
		});
	},
	/**
	 * Sets up the dynamic functionality of the product review section.
	 * @returns {undefined}
	 */
	productReviewsController: function() {
		$('select.productReviewSortSelect').select2({
			minimumResultsForSearch: -1
		});

		/**
		 * Retrieve the set of available reviews from the server.
		 * @returns {undefined}
		 */
		function getReviews() {
			let productReviewsListOuterContainer = $('.productReviewsListOuterContainer'),
				sortOrder = $('select.productReviewSortSelect').val(),
				verifiedPurchase = ($('#verifiedPurchase').prop('checked') === true ? 1 : null),
				overallRatingArr = [],
				overallRatingCheckboxes = document.querySelectorAll('.overallRating:checked'),
				loaderContainer = $('.loaderContainer');

			for (let i = 0; i < overallRatingCheckboxes.length; i++) {
				overallRatingArr.push(overallRatingCheckboxes[i].value);
			}

			$.ajax({
				url: "/product/getProductReviews",
				type: "GET",
				dataType: "html",
				data: {
					product_id: responsiveProduct.productId,
					sort_order: sortOrder,
					overall: overallRatingArr,
					verified_purchase: verifiedPurchase
				},
				beforeSend: function() {
					loaderContainer.show();
				},
				success: function(html) {
					let productReviewsListInnerContainer = $(html).filter(".productReviewsListInnerContainer");

					productReviewsListOuterContainer.html(productReviewsListInnerContainer);
				},
				complete: function() {
					initPhotoSwipe('.reviewsImagesAndVideos .reviewImg');

					responsiveProduct.timeToVoteController();

					$('html, body').animate({
						scrollTop: $('.productCustomerReviewsSection').offset().top
					}, 500);

					loaderContainer.fadeOut('slow');
				}
			});
		}

		$(document.body).on('change', 'select.productReviewSortSelect', function() {
			getReviews();
		});
		$(document.body).on('change', '.overallRating', function() {
			getReviews();
		});
		$(document.body).on('change', '#verifiedPurchase', function() {
			getReviews();
		});
		$(document.body).on('click', '.writeReviewBtn', function() {
			const pid = $(this).data('pid');
			if (pid) {
				window.location.href = '/review/write?productId=' + pid;
			}
		});
		$(document.body).on('click', '.editReviewBtn', function() {
			const reviewId = $(this).data('review-id');
			if (reviewId) {
				window.location.href = '/review/update?reviewId=' + reviewId;
			}
		});
	},
	/**
	 * Sets up all the YouTube videos.
	 * @returns {undefined}
	 */
	productYoutubeVideo: function() {
		let lcWidgetList = $('#lcWidgetList');

		if (lcWidgetList.length > 0) {
			let videoContainer = document.getElementById('productVideosList'),
				imgSize = 'hqdefault',
				LI = lcWidgetList.find('ul').first();

			const videoData = [];

			LI.children('li').map(function() {
				let $this = $(this);

				videoData.push({
					Id: $this.attr('id'),
					FullUrl: $this.children('div').attr('data-url'),
					videoThumbnail: `https://img.youtube.com/vi/${$this.attr('id')}/${imgSize}.jpg`,
					videoTitle: $this.find('.videoTitle').text()
				});
			});

			if (videoData.length > 0) {
				$.each(videoData, (i, d) => {
					let li = document.createElement('li');

					li.innerHTML += `
						<svg style="cursor:pointer; position: absolute; top: 20px; left: 20px; color: white; border-radius: 60px; border: 1.5px solid; font-size: 5rem; background: #8A8A8A; padding-left: 0.5rem;" class="target${i} bi bi-play-fill" width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M11.596 8.697l-6.363 3.692c-.54.313-1.233-.066-1.233-.697V4.308c0-.63.692-1.01 1.233-.696l6.363 3.692a.802.802 0 0 1 0 1.393z"/></svg>
						<img class="target${i} youTubeThumbnailImg" src="${d.videoThumbnail}" alt="${d.videoTitle}">
					`;
					if (d.videoTitle !== '') {
						li.innerHTML += `<div class="pt-3 px-2" style="max-width: 15rem; font-size: smaller;">${d.videoTitle}</div>`;
					}

					videoContainer.append(li);

					// Open the related video to the fancy box.
					$(`.target${i}`).click(function() {
						$.fancybox({
							type: 'iframe',
							href: `${d.FullUrl}`,
							width: 700,
							height: 400,
							fitToView: false,
							wrapCSS: 'productVideoIframe'
						});
					});
				});
			}
		}
	},
	/**
	 * Sets up the recently viewed item links with analytics.
	 * @returns {undefined}
	 */
	recentlyViewedItemsController: function() {
		let recentlyViewedItems = document.getElementById('recentlyViewedProductSection');

		if (recentlyViewedItems) {
			let $recentlyViewedItems = $(recentlyViewedItems),
				$productContainer = $('.productContainer', $recentlyViewedItems);

			for (let i = 0, t = $productContainer, l = t.length; i < l; i++) {
				let item = t[i],
					$anchor = $('a', item),
					$title = $('.productTitle', $anchor),
					titleText = $title.text();

				bindGAnchorEvent($anchor, 'Product', 'Recently Viewed Items', 'Slide Thumbnail', 'Click', titleText);
			}
		}
	},
	/**
	 * Initializes the report abuse's modal form and form submit event
	 * @returns {undefined}
	 */
	reportAbuseInit: function() {
		$('#reportAbuseModal').on('show.bs.modal', function(event) {
			const $Modal = $(this);

			$Modal.find('.modal-body > div.alert').remove();

			// Button that triggered the modal
			const button = event.relatedTarget;
			// Extract info from data-* attributes
			let reviewTitle = button.getAttribute('data-title'),
				reviewId = button.getAttribute('data-reviewid'),
				productName = button.getAttribute('data-product'),
				productId = button.getAttribute('data-productid');

			// Update the modal's content and remove if there are alerts
			$('#reportAbuseModalLabel').html('Flag review ' + reviewTitle + ' &mdash; ' + productName);
			grecaptcha.reset();
			$('#reportAbuseReason').val('');
			$('#reportAbuseReviewId').val(reviewId);
			$('#reportAbuseProductId').val(productId);

			$Modal.find('.formElemCont').show();
			$Modal.find('.modal-footer').show();
		});

		// To check if there's a pending request so we don't send multiple ajax requests
		let isPendingAjaxRequest = false;

		$('#reportAbuseForm').on('submit', function(event) {
			$('.alert-danger').remove();
			event.preventDefault();

			let productId = $('#reportAbuseProductId').val(),
				reviewId = $('#reportAbuseReviewId').val(),
				reason = $('#reportAbuseReason').val(),
				$ModalBody = $(this).find('.modal-body');

			if (grecaptcha.getResponse() == "") {
				$ModalBody.find('p.mt-2')
					.after('<div class="alert alert-danger d-flex align-items-center mt-2" role="alert"><div>Verification failed. Please try again</div></div>');
			} else if (!isPendingAjaxRequest) {
				isPendingAjaxRequest = true;
				// send request
				$.ajax({
					url: "/review/reportAbuse",
					type: "POST",
					data: {
						productId: productId,
						reviewId: reviewId,
						reason: reason
					}
				}).done(function(data) {
					let alertClass = 'alert-danger';

					if (data.success) {
						alertClass = 'alert-success';
						$ModalBody.find('.formElemCont').slideUp();
						$ModalBody.next('.modal-footer').hide();
					}

					$ModalBody.prepend(
						'<div class="alert ' + alertClass + ' d-flex align-items-center" role="alert"><div><p class="mb-0">' + data.message + "</p></div></div>"
					);
				}).always(function() {
					isPendingAjaxRequest = false;
				});
			}
		});
	},
	/**
	 * Opens the review video modal.
	 * @returns {undefined}
	 */
	reviewVideo: function() {
		let iframeSrc = $(this).closest('.reviewImageInnerContainer').find('input[type=hidden]').val();

		$.fancybox({
			type: 'iframe',
			href: iframeSrc,
			fitToView: true
		});
	},
	/**
	 * Filters compatible vehicle list in Compatible Vehicles section.
	 * @returns {undefined}
	 */
	searchCompatibleProduct: function() {
		$('#compatibleProductSearch').on('keyup', function() {
			let value = $(this).val().toLowerCase();

			$('.compatibleVehicleList').find('.compatibleVehicleName').filter(function() {
				let $this = $(this);

				if (($this.find('a,b').data('displayName')||'').toLowerCase().indexOf(value) > -1) {
					$this.show();
				} else {
					$this.hide();
				}
			});
		});
	},
	/**
	 * Prompts users to set a compatible vehicle or visit the storefront when clicking a vehicle button.
	 * @returns {undefined}
	 */
	compatibleVehicleSelector: function() {
		let compatibleSection = $('#compatibleVehicleSection'),
			$modalTemplate = $('#compatibleVehicleModal');

		if (compatibleSection.length === 0 || $modalTemplate.length === 0) {
			return;
		}

		let hasSelectedVehicle = Boolean(compatibleSection.data('has-selected-vehicle')),
			selectedVehicleYearModel = compatibleSection.data('selected-vehicle-year-model') || '',
			selectedVehicleDisplayName = compatibleSection.data('selected-vehicle') || '',
			$setVehicleBtn = $modalTemplate.find('.compatibleVehicleSetBtn'),
			$storefrontBtn = $modalTemplate.find('.compatibleVehicleStorefrontBtn'),
			$cancelBtn = $modalTemplate.find('.closeModalBtn.btn');

		$(document.body).on('click', '.compatibleVehicleName a', function(e) {
			e.preventDefault();

			let $button = $(this),
				year = $button.data('year'),
				make = $button.data('make'),
				model = $button.data('model'),
				vehicleTypeGroup = $button.data('vehicleTypeGroup') || '',
				displayName = $button.data('display-name') || $button.text().trim(),
				yearModel = (year && model ? year + ' ' + model : displayName),
				modalTitle = 'Choose how you want to continue',
				setVehicleCta = 'Set this vehicle and stay on this page',
				storefrontCta = 'See the ' + yearModel + ' storefront',
				cancelCta = hasSelectedVehicle ? 'Cancel, keep my current vehicle' : 'Cancel, browse without a vehicle';

			if (hasSelectedVehicle && (selectedVehicleYearModel || selectedVehicleDisplayName)) {
				let selectedVehicleLabel = selectedVehicleYearModel || selectedVehicleDisplayName;

				modalTitle = 'You currently have a ' + selectedVehicleLabel + ' selected';
				setVehicleCta = 'Change vehicle and stay on this page';
			}

			$modalTemplate.find('.compatibleVehicleModalTitle').text(modalTitle);
			$modalTemplate.find('.compatibleVehicleModalSubtitle').text('Do you want to:');
			$modalTemplate.find('.compatibleVehicleSetBtn').text(setVehicleCta);
			$modalTemplate.find('.compatibleVehicleStorefrontBtn').text(storefrontCta);
			$cancelBtn.text(cancelCta);

			// This implements the logic found in afg-sonic.js at line 191
			let updateButtonData = function($btn) {
				$btn.data('year', year)
					.data('make', make)
					.data('model', model)
					.data('vehicleTypeGroup', vehicleTypeGroup)
					// Only set YMM - leave BTA blank so users can select details when needed.
					.data('body', '')
					.data('trim', '')
					.data('audio', '');
			};

			updateButtonData($setVehicleBtn);
			updateButtonData($storefrontBtn);

			$modalTemplate.removeClass('d-none');
			sonicGlobal.overlayActivate(true);
			$('.black-overlay').css('pointer-events', 'none');
		});

		$modalTemplate.find('.closeModalBtn').click(function(e) {
			e.preventDefault();
			$modalTemplate.addClass('d-none');
			sonicGlobal.overlayDeactivate();
			$('.black-overlay').css('pointer-events', 'unset');
		});

		$modalTemplate.find('.compatibleVehicleActionBtn').click(function(e) {
			e.preventDefault();
			$modalTemplate.addClass('d-none');
			sonicGlobal.overlayDeactivate();
			$('.black-overlay').css('pointer-events', 'unset');
		})
	},
	/**
	 * Sets up the video order in the slider.
	 * @returns {undefined}
	 */
	setProductVideoOrder: function() {
		if ($('.productVideo').length > 0) {
			let preElm = $('.slidesRailsThumbnail figure:nth-child(2)'),
				nextElm = $('.productImage.productVideo').first();

			nextElm.insertAfter(preElm);

			let preElm1 = $('.mainImage figure:nth-child(2)'),
				nextElm1 = $('.mainProductImageWrapper.productVideo').first();

			nextElm1.insertAfter(preElm1);
		}
	},
	/**
	 * Sets up all the slick sliders on the page other than the image gallery.
	 * @returns {undefined}
	 */
	slickSlider: function() {
		$('.acimaMessageSlider').slick({
			arrows: true,
			autoplay: true,
			autoplaySpeed: 3000,
			dots: false,
			infinite: true,
			mobileFirst: true,
			slidesToScroll: 1,
			slidesToShow: 1,
			variableWidth: true
		});

		$('.bundleSlider').slick({
			arrows: false,
			dots: true,
			infinite: false,
			mobileFirst: true,
			responsive: [
				{
					breakpoint: 992,
					settings: {
						arrows: true,
						dots: false
					}
				}
			],
			slidesToScroll: 1,
			slidesToShow: 1,
			variableWidth: true
		});

		if ($('#MainWrapper').innerWidth() > 992) {

			$('.hasSlider').slick({
				arrows: true,
				dots: false,
				infinite: false,
				mobileFirst: true,
				responsive: [
					{
						breakpoint: 1920,
						settings: {
							arrows: true,
							dots: false,
							slidesToScroll: 7,
							slidesToShow: 7
						}
					},
					{
						breakpoint: 1386,
						settings: {
							arrows: true,
							dots: false,
							slidesToScroll: 6,
							slidesToShow: 6
						}
					},
					{
						breakpoint: 1200,
						settings: {
							arrows: true,
							dots: false,
							slidesToScroll: 5,
							slidesToShow: 5
						}
					}
				],
				variableWidth: true
			});
		}
	},
	/**
	 * Sets up the analytics for the links in the sonic points section and adds the Fancybox event handler.
	 * @returns {undefined}
	 */
	sonicPointsController: function() {
		let $sonicPoints = $('.sonicPoints');

		if ($sonicPoints.length > 0) {
			$(document.body).on('click', '.sonicPoints .point', function(e) {
				let $this = $(this),
					href = $this.data('link'),
					point = $this.data('point');

				e.preventDefault();
				$.fancybox({
					type: 'iframe',
					href: href,
					autoCenter: true,
					wrapCSS: 'customFancyBox sonicPoint-' + point
				});
			});
		}
	},
	/**
	 * Utility for custom horizontal tab pane carousel slider.
	 */
	tabPaneCustomSlider: function () {
		let customSlider = $('.tabPaneCustomSlider');
		customSlider.each(function () {
			let $this = $(this),
				sliderElementOuterWidth = $this.outerWidth(),
				sliderScrollBar = $this.find('.horizontalCustomScrollbar'),
				sliderElements = sliderScrollBar.find('.tabPaneCustomSlider'),
				sliderFirstElement = sliderElements.eq(0),
				sliderLastElement = sliderElements.last(),
				sliderArrows = $this.find('.arrow'),
				sliderArrowRight = $this.find('.arrowRight'),
				sliderArrowLeft = $this.find('.arrowLeft'),
				sliderElementWidth = 0;

			sliderElements.each(function (){
				sliderElementWidth += ($(this).outerWidth() + 16);
			});

			let customSliderWidth = sliderElementWidth;

			if (!window.sonicGlobal.isMobile) {
				if (customSliderWidth > sliderElementOuterWidth) {
					sliderArrowRight.show();
				}
				$(window).on('resize', function() {
					sliderElementOuterWidth = $this.outerWidth();
					(customSliderWidth > sliderElementOuterWidth) ? sliderArrowRight.show() : sliderArrowRight.hide();
				});
				sliderArrows.click(function() {
					let x;

					if ($(this).hasClass('arrowRight')) {
						x = (sliderElementOuterWidth / 2) + sliderScrollBar.scrollLeft();
						sliderScrollBar.animate({ scrollLeft: x });
						(sliderLastElement.isInViewport()) ? sliderArrowRight.hide() : sliderArrowRight.show();
						if (x > 0) {
							sliderArrowLeft.show();
						}
					} else {
						x = (sliderElementOuterWidth / 2) - sliderScrollBar.scrollLeft();
						sliderScrollBar.animate({ scrollLeft: -x });
						(sliderFirstElement.isInViewport()) ? sliderArrowLeft.hide() : sliderArrowLeft.show();
						sliderArrowRight.show();
					}
				});
				$.fn.isInViewport = function() {
					let $this = $(this),
						elementLeft = $this.offset().left,
						elementRight = elementLeft + $this.outerWidth(),
						viewportLeft = $(window).scrollLeft(),
						viewportRight = viewportLeft + $(window).width();

					return elementRight > viewportLeft && elementLeft < viewportRight;
				};
			}
		});
	},
	/**
	 * Processes all review items and binds the items in timeToVote container
	 * to process an ajax call to vote for said review.
	 *
	 * Vote icons are cleared and thank you messaging is provided on success.
	 * @returns {undefined}
	 */
	timeToVoteController: function() {
		let $productReviewsContainer = $('#reviewSection'),
			$reviews = $('.reviews', $productReviewsContainer),
			$postHelpfulCount = $('.postHelpfulCount', $reviews),
			$timeToVote = $('.timeToVote', $reviews),
			rateVoteURL = '/product/rateReview';

		for (let i = 0, t = $timeToVote, l = t.length; i < l; i++) {
			let item = t[i],
				postHelpfulCount = $postHelpfulCount[i];

			processItem(item, postHelpfulCount);
		}

		function processItem(item, postHelpfulCount) {
			// Mustache: .helpful is inside .timeToVote
			// PHP view: .helpful is in a sibling <p> outside .timeToVote
			let $helpful = $('.helpful', item);
			if (!$helpful[0]) {
				$helpful = $(item).siblings().find('.helpful');
			}

			if ($helpful[0]) {
				bindItem(item, $helpful, postHelpfulCount);
			}
		}

		function bindItem(item, $helpful, postHelpfulCount) {
			let helpfulObj = {
					review_id: $helpful[0].getAttribute('data-review-id'),
					value: $helpful[0].getAttribute('data-value'),
				},
				helpfulClosure = function(item, $helpful, postHelpfulCount, helpfulObj) {
					return function(e) {
						rateReview(e, item, $helpful, postHelpfulCount, helpfulObj);
					};
				}(item, $helpful, postHelpfulCount, helpfulObj);

			$helpful.click(helpfulClosure);
		}

		function rateReview(e, item, $helpful, postHelpfulCount, obj) {
			e.preventDefault();

			let closure = function(item, $helpful, postHelpfulCount, obj) {
				return function(e) {
					rateReviewCallback(e, item, $helpful, postHelpfulCount, obj);
				};
			}(item, $helpful, postHelpfulCount, obj);

			$.get(rateVoteURL, obj).done(closure);
		}

		function rateReviewCallback(e, item, $helpful, postHelpfulCount, obj) {
			let date = new Date();

			if ('success' == e.type) {
				if ($.contains(item, $helpful[0])) {
					// Mustache: .helpful is inside .timeToVote — replace its contents
					item.innerHTML = '<p>Thank you for your feedback</p>';
				} else {
					// PHP view: .helpful is in a sibling <p> — replace that <p>
					$helpful.closest('p').replaceWith('<p class="m-0">Thank you for your feedback</p>');
				}
				updatePostHelpfulCount(postHelpfulCount, obj);
				date.setTime(date.getTime() + (1000 * 60 * 60 * 24 * 30));
				document.cookie = 'review_id_' + obj.review_id + '=1; expires=' + date.toGMTString();
			} else if ('limit_exceed' == e.subType) {
				let $msg = $('<p class="m-0">').text(e.message);
				if ($.contains(item, $helpful[0])) {
					item.innerHTML = '';
					$(item).append($msg);
				} else {
					$helpful.closest('p').replaceWith($msg);
				}
				date.setTime(date.getTime() + (1000 * 60 * 60 * 24 * 30));
				document.cookie = 'review_id_' + obj.review_id + '=1; expires=' + date.toGMTString();
			}
		}

		function updatePostHelpfulCount(postHelpfulCount, obj) {
			let $postHelpfulCount = $(postHelpfulCount),
				$span = $('span', $postHelpfulCount),
				voteCount = parseFloat($span.text());

			if ('1' == obj.value) {
				voteCount++;
				if ($postHelpfulCount.hasClass('postHelpfulCountHide')) {
					$postHelpfulCount.removeClass('postHelpfulCountHide');
				}
			}
			$span.text(voteCount);
		}
	},
	/**
	 * Creates a checkbox list for the extended warranty options.
	 * On checkbox change:
	 *   - Updates product price
	 *   - Adds/removes 'with warranty' text following price
	 * @returns {undefined}
	 */
	warrantyController: function() {
		let extendedOfferCards = $('#extended-offer-cards'),
			extendedOfferCheckboxes = extendedOfferCards.find('.extended-offer-checkbox'),
			warrantyIdInput = $('#selected-extended-warranty-id');

		extendedOfferCheckboxes.on('change', function() {
			let $this = $(this);

			extendedOfferCheckboxes.not(this).prop('checked', false);
			if ($this.is(':checked')) {
				$this.closest('.extended-offer-card').addClass('checked');
				extendedOfferCheckboxes.not(this).closest('.extended-offer-card').removeClass('checked');
			} else {
				$this.closest('.extended-offer-card').removeClass('checked');
			}

			if (warrantyIdInput.length > 0) {
				let warrantyId = $this.data('id'),
					warrantyPrice = $this.data('price'),
					withWarrantyText = $('#with-warranty-text');

				window.responsiveProduct.withWarrantyPrice(warrantyPrice, $this.is(':checked'));
				if (warrantyIdInput.val() == warrantyId) {
					warrantyIdInput.val('0');
					withWarrantyText.removeClass('active').data('price', '');
				} else {
					warrantyIdInput.val(warrantyId);
					withWarrantyText.addClass('active').data('price', warrantyPrice);
				}
			}
		});
	},
	/**
	 * Binds all .diagram elements to fire openModal on click. The modal is inline and references
	 * #wiringGuideModalContainer. Prior to open, the h3 and image children of wiringGuideModalContainer
	 * are updated to match the text and source of the h3 and image within the .diagram element.
	 * @returns {undefined}
	 */
	wiringGuidesController: function() {
		let $wiringDiagram = $('#wiringDiagram');

		if ($wiringDiagram.length) {
			let $diagramList = $('.diagram', $wiringDiagram),
				$wiringGuideModalContainer = $('#wiringGuideModalContainer'),
				$wiringGuideModalImage = $('img', $wiringGuideModalContainer),
				$wiringGuideModalTitle = $('h3', $wiringGuideModalContainer);

			for (let i = 0, t = $diagramList, l = t.length; i < l; i++) {
				let $item = $(t[i]),
					$itemTitle = $item.children('h3'),
					$itemImage = $item.children('img'),
					itemTitleString = $itemTitle.text(),
					itemImageSource = $itemImage[0].getAttribute('src');

				$item.click(openDiagram);

				function openDiagram() {
					$wiringGuideModalTitle.text(itemTitleString);
					$wiringGuideModalImage[0].src = itemImageSource;
					openModal('#wiringGuideModalContainer', 'auto', 'auto', 'inline', null, null, 'wiring-guides-wrap');
				}
			}
		}
	},
	/**
	 * Update the product price display with the value of the warranty added.
	 * @param {float} amt   The price of the warranty being added or removed.
	 * @param {bool}  state TRUE to add the warranty, FALSE to remove it.
	 * @returns {undefined}
	 */
	withWarrantyPrice: function(amt, state) {
		let priceSection = $('#product-price-text'),
			curPrice = parseFloat(priceSection.data('orig-price'));

		if (true === state) {
			curPrice += parseFloat(amt);
		}

		priceSection.data('price', curPrice.toFixed(2));

		if (curPrice < 0.005) {
			curPrice = 'FREE';
		} else {
			curPrice = '$' + curPrice.toFixed(2);
		}
		priceSection.text(curPrice);
	}
};
window.responsiveProduct = responsiveProduct;

// DOM ready
$(function() {
	responsiveProduct.init();
});
